import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import React from "react";
import { Message } from "components/Atoms/Message";
import { routes } from "utilities/routing/generatedRoutes";

const NoAdvancingTemplatesMessageBox = () => {
  const canConfigureTemplates = site.permissions.canConfigureTemplates;

  return (
    <Message type="error" className="flex gap" style={{ padding: 4 }}>
      <div className="grow1 padding">
        {canConfigureTemplates
          ? "Configure at least 1 advancing template"
          : "Ask an admin to configure advancing templates"}
      </div>
      {canConfigureTemplates && <div>
        <PhosphorGearAnchor
          href={routes.advancingTemplate_List().absolute}
          layout="in-square"
          backgroundColor="light"
          padding="large"
        />
      </div>}
    </Message>
  );
};

export default NoAdvancingTemplatesMessageBox;
